import dotenv from 'dotenv';

// Load environment variables from .env file
dotenv.config();

export const config = {
  falkorDB: {
    host: 'localhost',
    port: 6379,
    username: '',
    password: '',
  },
  mcp: {
    apiKey: process.env.EE_API_KEY || '*',
  },
};